import { useDashSections } from '../../../hooks/mechanical/useDashSections';
import { useDriveCycleSections } from '../../../hooks/mechanical/useDriveCycleSections';
import { useOBDSections } from '../../../hooks/mechanical/useOBDSections';
import { useUnderHoodSections } from '../../../hooks/mechanical/useUnderHoodSections';
import { GradeUIBar } from './GradeUIBar';
import { useParsedGrades } from './useParsedGrades';

export const MechanicalGrades = () => {
  const underHoodSections = useUnderHoodSections();
  const driveCycleSections = useDriveCycleSections();
  const obdSections = useOBDSections();
  const dashSections = useDashSections();

  const grades = useParsedGrades([...underHoodSections, ...driveCycleSections, ...obdSections, ...dashSections]);
  return <GradeUIBar gradePercents={grades} />;
};
